import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["checked", "indeterminate", "isDisabled", "size"];

var _CHECKBOX_HIGHLIGHT_S, _templateObject, _templateObject2, _templateObject3, _templateObject4;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React from 'react';
import { IconCheck, IconRemove } from "../../icons";
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { CHECKBOX_SIZES } from "../constants";
import { BREAKPOINTS, centerContent, getRem, transitionAnimation } from "./../../core";
import { jsx as _jsx } from "react/jsx-runtime";
var CHECKBOX_HIGHLIGHT_SIZES = (_CHECKBOX_HIGHLIGHT_S = {}, _defineProperty(_CHECKBOX_HIGHLIGHT_S, CHECKBOX_SIZES.LARGE, '40px'), _defineProperty(_CHECKBOX_HIGHLIGHT_S, CHECKBOX_SIZES.SMALL, '32px'), _defineProperty(_CHECKBOX_HIGHLIGHT_S, CHECKBOX_SIZES.STANDARD, '36px'), _CHECKBOX_HIGHLIGHT_S);
var INDICATOR_SIZE = getRem('18px');
var ICON_SIZE = getRem('24px');
var StyledCheckboxIndicator = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 2px solid ", ";\n  border-radius: ", ";\n  box-sizing: border-box;\n  display: inline-flex;\n  flex-shrink: 0;\n  height: ", ";\n  margin: 0 ", ";\n  position: relative;\n  width: ", ";\n\n  &::after {\n    ", "\n    ", "\n        border-radius: ", ";\n    content: '';\n    display: inline-block;\n    height: ", ";\n    width: ", ";\n\n    @media ", " {\n      height: ", ";\n      width: ", ";\n    }\n  }\n\n  ", ";\n  ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.color.additional.light.value;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.color.gray[700].value;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.size.borderRadius.extraSmall.value;
}, INDICATOR_SIZE, getRem('15px'), INDICATOR_SIZE, centerContent, transitionAnimation('background-color'), function (_ref4) {
  var theme = _ref4.theme;
  return theme.size.borderRadius.full.value;
}, getRem(CHECKBOX_HIGHLIGHT_SIZES[CHECKBOX_SIZES.LARGE]), getRem(CHECKBOX_HIGHLIGHT_SIZES[CHECKBOX_SIZES.LARGE]), BREAKPOINTS.L, function (_ref5) {
  var size = _ref5.size;
  return getRem(CHECKBOX_HIGHLIGHT_SIZES[size]);
}, function (_ref6) {
  var size = _ref6.size;
  return getRem(CHECKBOX_HIGHLIGHT_SIZES[size]);
}, function (_ref7) {
  var checked = _ref7.checked,
      theme = _ref7.theme;
  return checked && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      background-color: ", ";\n      border-color: ", ";\n    "])), theme.color.primary[500].value, theme.color.primary[500].value);
}, function (_ref8) {
  var checked = _ref8.checked,
      isDisabled = _ref8.isDisabled,
      theme = _ref8.theme;
  return isDisabled && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      background-color: ", ";\n      border-color: ", ";\n    "])), checked && theme.color.gray[300].value, theme.color.gray[300].value);
});
var StyledIcon = styled(IconCheck).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['indeterminate'].includes(prop);
  }
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n    fill: ", ";\n  height: ", ";\n  opacity: ", ";\n  width: ", ";\n"])), centerContent, transitionAnimation('opacity'), function (_ref9) {
  var theme = _ref9.theme;
  return theme.color.additional.light.value;
}, function (_ref10) {
  var indeterminate = _ref10.indeterminate;
  return indeterminate ? ICON_SIZE : INDICATOR_SIZE;
}, function (_ref11) {
  var checked = _ref11.checked;
  return checked ? 1 : 0;
}, function (_ref12) {
  var indeterminate = _ref12.indeterminate;
  return indeterminate ? ICON_SIZE : INDICATOR_SIZE;
});

var CheckboxIndicator = function CheckboxIndicator(_ref13) {
  var checked = _ref13.checked,
      indeterminate = _ref13.indeterminate,
      isDisabled = _ref13.isDisabled,
      size = _ref13.size,
      other = _objectWithoutProperties(_ref13, _excluded);

  return /*#__PURE__*/_jsx(StyledCheckboxIndicator, _objectSpread(_objectSpread({
    checked: checked,
    isDisabled: isDisabled,
    size: size
  }, other), {}, {
    children: /*#__PURE__*/_jsx(StyledIcon, {
      as: indeterminate && IconRemove,
      checked: checked,
      indeterminate: indeterminate
    })
  }));
};

CheckboxIndicator.displayName = "CheckboxIndicator";
CheckboxIndicator.propTypes = {
  /** The current value of checkbox - checked or unchecked */
  checked: PropTypes.bool,

  /** Changes the icon and sets checkbox indeterminate parameter state */
  indeterminate: PropTypes.bool,

  /** Disables to change the value of checkbox and shows it visually disabled */
  isDisabled: PropTypes.bool,

  /** Indicator clickable area size */
  size: PropTypes.oneOf(Object.values(CHECKBOX_SIZES))
};
CheckboxIndicator.defaultProps = {
  checked: false,
  indeterminate: false,
  isDisabled: false,
  size: CHECKBOX_SIZES.STANDARD
};
export { CheckboxIndicator, StyledCheckboxIndicator };